import React from 'react'

import {
  Charts,
} from "xsolla-uikit";
import {
  mapdata,
} from "../../data/mapdata";
import { PaChartCard } from "../uikit2/PaChartCard";

import { CssChartsGrid } from "./../uikit2";
import { subsPlans } from "./../../data/subsPlans";
import { CSSchartfix } from "../PAdashboard";
import { PAchartMap } from '../PAcharts';






export default function PAsubsCharts ({charts = [
  'time',
  'plans',
  // 'country'
]}) {
  return (<div>
  <CssChartsGrid
    charts={charts}
    // cols='1fr'
  >
    {charts.indexOf('time') > -1 &&
    <PaChartCard title="Subscribers by plans" cols={2}>
      <PAchartSubsPlans/>
    </PaChartCard>}

    {charts.indexOf('plans') > -1 &&
    <PaChartCard title="Subscribers by month" cols={2}>
      <PAchartSubsUsers/>
    </PaChartCard>}

    {charts.indexOf('country') > -1 &&
    <PaChartCard title="Subscribers by geography" cols={2}>
      {/* <PAchartUsersMap/> */}
      <PAchartMap/>
    </PaChartCard>}

  </CssChartsGrid>
</div>)}




export function PAchartSubsPlans() {
  return (
    <CSSchartfix>
    <Charts
        options={{
          chart: {
            height: 280,
            type: 'column'
          },
          tooltip: {
            header: 'Today',
            total: 21
          },
          legend: {
            enabled: false
          },
          xAxis: {
            categories: subsPlans.map((el, i)=> (i < 4) ? el['label'] : null)
          },
          yAxis: {
            title: {
              text: ''
            },
            stackLabels: {
              format: '{total} users'
            }
          },
          series: [
            {
              name: '',
              data: [1024, 750, 100, 600 ]
            }
          ]
        }}
      />
    </CSSchartfix>
  )
}



export function PAchartSubsUsers() {
  return (
    <CSSchartfix>
    <Charts
      options={{
        chart: {
          height: 280,
          type: 'column'
        },
        tooltip: {
          header: 'Today'
        },
        xAxis: {
          categories: ['April', 'May', 'June', 'July', 'August',]
        },
        yAxis: {
          title: {
            text: 'Total fruit consumption'
          }
        },
        series: [
          {
            name: 'Users, stopped subscription',
            data: [0, 30, 70, 10, 40],
            colorIndex: 4,
          },
          {
            name: 'New subscribers',
            data: [300, 200, 400, 450, 100],
            colorIndex: 0,
          },


        ]
      }}
    />
  </CSSchartfix>
  )
}


export function PAchartUsersMap() {
  return (
    <CSSchartfix>
      <Charts
          options={{
            chart: {
              height: 280,
              type: 'column'
            },
            tooltip: {
              header: "October 13, 2018",
              valueSuffix: "/km²"
            },
            colorAxis: {
              max: 300
            },
            series: [
              {
                joinBy: ["iso-a2", "code"],
                data: mapdata
              }
            ]
          }}
          constructorType="mapChart"
        />
    </CSSchartfix>
  )
}

